
import {
    sha256
} from 'js-sha256'
const tabs = {
    namespaced: true,
    state: {
        keys: {

        },
        i: 0
    },
    mutations: {
        clearTabId: (state, key) => {
            delete state.keys[key]
        },
        setTab: (state, {key, value}) => {
            state.keys[key] = value
        }
    },
    getters: {
        newTabId: (state) => {
            const p = ++state.i
            var key = ''
            do {
                key = sha256('TabId-' + new Date().toUTCString() + "|" + p + "|" + Math.random())
            } while (state.keys[key] !== undefined);
            return key
        },
        getTab: (state) => (key) => {
            return state.keys[key]
        }
    },
    actions: {

    }
}

export default tabs;



// WEBPACK FOOTER //
// ./resources/js/store/modules/tabs.js